import { createAction } from '@reduxjs/toolkit'

export const setUserSignedState = createAction<{
  isSigned: boolean
  isTotpValidated?: boolean
  expiry: number
  account: string | null | undefined
  roles: string[]
}>('user/setUserSignedState')
